import axios from "axios";
import router from "./router";
import { ElMessageBox } from "element-plus";
import { Toast } from "vant";
import { isTokenExpiringSoon } from "./utils/jwt";

axios.defaults.timeout = 10000;
//post请求头
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
// axios.defaults.withCredentials = true;
// 环境的切换,vue-cli3 开发就是dev,打包就是production
if (process.env.NODE_ENV == "development") {
  // 开发环境使用代理，不设置 baseURL，让请求走 vue.config.js 中的代理配置
  axios.defaults.baseURL = ''
} else if (process.env.NODE_ENV == "production" || process.env.NODE_ENV == 'test') {
  // axios.defaults.baseURL = "https://api.gdcoh.com/tecs/";
  axios.defaults.baseURL=process.env.VUE_APP_API_BASE_URL

}

//请求拦截
axios.interceptors.request.use(
  (config) => {
    const userInfo = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo")) || null;
    const token = (userInfo && userInfo.token) || null;
    if (token) {
      config.headers.Authorization = "Bearer " + token;
      config.headers.common["token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 对于二进制响应（blob/arraybuffer）直接透传，避免包装破坏数据
    const rt = response && response.config && response.config.responseType;
    if (rt === 'blob' || rt === 'arraybuffer' || response.data instanceof Blob) {
      return Promise.resolve(response);
    }
    // console.log(response);
    return Promise.resolve({
      ...response,
      data: {
        data: response.data,
        stime: response.headers.stime,
        success: response.status == 200,
      },
    });
  },
  // 服务器状态码不是200的情况
  (error) => {
    // 如果没有response，可能是网络错误，直接reject
    if (!error.response) {
      return Promise.reject(error);
    }
    
    if(error.response.status==400){
      const errorData = error.response.data;
      let errorMessage = '请求失败，请稍后重试';
      
      // 优先检查 debug 字段
      if (errorData.debug) {
        errorMessage = errorData.debug;
      }
      // 检查 message 字段（后端 BadRequestException 通常在这里）
      else if (errorData.message) {
        errorMessage = errorData.message;
      } 
      // 检查 title 字段
      else if (errorData.title) {
        errorMessage = errorData.title;
      }
      // 如果是表单验证错误（Spring Validation）
      else if (errorData.data && typeof errorData.data === 'object') {
        const fieldErrors = Object.values(errorData.data).filter(msg => msg);
        if (fieldErrors.length > 0) {
          errorMessage = fieldErrors.join('；');
        }
      }
      // 如果 errorData 本身就是字符串
      else if (typeof errorData === 'string') {
        errorMessage = errorData;
      }
      // 如果都没有，尝试从 errorData 中提取任何有用的信息
      else if (errorData && typeof errorData === 'object') {
        // 尝试查找常见的错误字段
        const possibleFields = ['error', 'msg', 'errorMessage', 'detail'];
        for (const field of possibleFields) {
          if (errorData[field]) {
            errorMessage = String(errorData[field]);
            break;
          }
        }
      }
      
      Toast(errorMessage);
    }
    //状态码错误处理
    if (error.response.status == "401" || error.response.status == 401) {
      // 检查是否在考试页面，且是考试相关请求
      const isExamPage = window.location.pathname.includes('/examinationDetails') || 
                         window.location.pathname.includes('/mobileExamination');
      const isExamRequest = error.config && error.config.url && error.config.url.includes('/api/my/exam/');
      
      // 如果在考试页面且是考试相关请求，静默处理，不弹出登录框，不跳转
      if (isExamPage && isExamRequest) {
        // 静默 reject，由调用方处理错误，避免考试中断
        return Promise.reject(error.response);
      }
      
      // 非考试页面或非考试请求，正常弹出登录框
      ElMessageBox({
        title: "登录失效",
        message: error.response.data.message,
        center: true,
        confirmButtonText: "重新登录",
      }).then(() => {
        sessionStorage.removeItem("userInfo");
        localStorage.removeItem('persistUser');

        router.replace({
          path: "/",
        });
      });
    }

    return Promise.reject(error.response);
  }
);

//get请求封装
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

//post请求封装,
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

// get 二进制（验证码/文件等）
export function getBlob(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params, responseType: 'blob' })
      .then((res) => {
        resolve({ blob: res.data, headers: res.headers });
      })
      .catch((err) => {
        reject(err && err.data ? err.data : err);
      });
  });
}

//post请求封装
export function postWithFile(url, params) {
  let config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

//delete方法的删除参数有点问题{ data: params }
export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, { data: params })
      .then((res) => {
        resolve(res.data);
        console.log("成功删除");
      })
      .catch((err) => {
        reject(err.data);
        console.log("删除失败");
      });
  });
}
const http = {
  get,
  post,
  getBlob,
  postWithFile,
  put,
  deletes,
};
export default {
  install: (app) => {
    app.config.globalProperties["$https"] = http;
  },
};
